import React from 'react';
import { IfmsRoute }from '../../../config/types';

const IfmsSetup = React.lazy(() => import('../ifmsSetup/IfmsSetup'));

const routes:Array<IfmsRoute> = [
  {path: '/settings', component: IfmsSetup},
];

export default routes;